/**
 * Maps the short language codes returned by `/dms/v1/available-languages`
 * (e.g. `cs`) to the full locale identifiers the messaging/email endpoints
 * expect in their `locale` path segment (e.g. `cs-CZ`).
 */
export const localeByLanguage: Record<string, string> = {
  en: 'en-GB',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  nl: 'nl-NL',
  pl: 'pl-PL',
  cs: 'cs-CZ',
  de: 'de-DE',
  sk: 'sk-SK',
};
